import axios from '@/libs/api.request'
import { sceneApi } from '@/configs/index'
import { baseAjaxErr, addErrorLog } from '@/configs/publicFn'

export const getRouterReq = (access) => {
  return axios.request({
    url: 'get_router',
    params: {
      access
    },
    method: 'get'
  })
}

/**
 * 基础设置-获取数据字典接口
 * @type {string}
 */
export const dictionaryListUrl = sceneApi + 'basecenter/dictionary/list'

/**
 * 获取账号品牌，区总，地区，门店管辖列表
 * @type {string}
 */
export const usercompanyListListUrl = sceneApi + 'polymerize/1.0/rbac/user/company/list'

/**
 * 基础设置-获取菜单接口
 * @type {string}
 */
export const userMenuListUrl = sceneApi + '/menu/list'

export const dictionaryList = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.jsonp(dictionaryListUrl, { params: data }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        return Promise.reject(err)
      })
  })
}

export const userMenuList = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.jsonp(userMenuListUrl, { params: data }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        return Promise.reject(err)
      })
  })
}

/**
 * 门店-获取门店详情
 * @type {string}
 */
export const getShopDetailUrl = sceneApi + 'basecenter/1.0/shop/detail'

export const getShopDetail = (vm, shopId, token) => {
  return new Promise((resolve, reject) => {
    vm.$http.jsonp(getShopDetailUrl + '/' + shopId + '?token=' + token).then(res => {
      if (res.data.code === 200) {
        resolve(res.data.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        reject(err)
      })
  })
}
/**
 * 门店-获取门店详情
 * @type {string}
 */
export const getShopListUrl = sceneApi + 'basecenter/1.0/shop/list'

export const getShopList = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.jsonp(getShopListUrl, { params: data }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        reject(err)
      })
  })
}

/**
 * 人事-工作人员列表接口
 * @type {string}
 */
export const getSaleListUrl = sceneApi + 'staff/1.0/basic/getStaffBasicList'

export const getSaleList = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.jsonp(getSaleListUrl, { params: data }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        reject(err)
      })
  })
}

/**
 * 品牌、地区、区域
 * @type {string}
 */
export const getNameByIdUrl = sceneApi + 'basecenter/1.0/company/getNameById'

export const getNameById = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.jsonp(getNameByIdUrl, { params: data }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        reject(err)
      })
  })
}

/**
 * 登录-获取登陆账号下 门店列表 角色列表
 * @type {string}
 */
export const getUsergetallListUrl = sceneApi + 'basecenter/1.0/auth/userpermission/getall'
export const getUsergetallList = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.jsonp(getUsergetallListUrl, { params: data }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        vm.$Message.error({ content: '服务器繁忙，请稍后再试！', closable: true, duration: 3 })
        return Promise.reject(err)
      })
  })
}

/**
 * 权限--获取用户参数列表
 * @type {string}
 */
export const getAuthUserParamUrl = sceneApi + 'basecenter/1.0/auth/userParam/get'
export const getAuthUserParam = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.jsonp(getAuthUserParamUrl, { params: data }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        vm.$Message.error({ content: '服务器繁忙，请稍后再试！', closable: true, duration: 3 })
        return Promise.reject(err)
      })
  })
}

/**
 * 权限--获取用户参数列表
 * @type {string}
 */
export const usercompanyListList = (vm, data) => {
  return new Promise((resolve, reject) => {
    vm.$http.jsonp(usercompanyListListUrl, { params: data }).then(res => {
      if (res.data.code === 200) {
        resolve(res.data.data)
      } else {
        baseAjaxErr(vm, res)
      }
    })
      .catch(err => {
        addErrorLog(err)
        vm.$Message.error({ content: '服务器繁忙，请稍后再试！', closable: true, duration: 3 })
        return Promise.reject(err)
      })
  })
}
